import {ChangeDetectionStrategy, Component, input, output} from '@angular/core';
import {TranslatePipe} from '@brunata-angular/util';

@Component({
    selector: 'app-input-file-drop-zone',
    standalone: true,
    imports: [TranslatePipe],
    template: `
        <div class="card dropzone" [class.filled]="title() !== null">
            <input
                class="file-input"
                type="file"
                [multiple]="multiple()"
                (change)="handleFileInput($event.target)" />
            @if (badge(); as badge) {
                <span
                    class="badge corner"
                    [class.text-bg-primary]="!mutedBadge()"
                    [class.text-bg-secondary]="mutedBadge()">
                    {{ badge }}
                </span>
            }
            @if (title(); as title) {
                <span class="title">{{ title }}</span>
            } @else {
                <i class="bi bi-upload" style="font-size: 2rem"></i>
            }
            <span [class.form-text]="title() !== null">
                {{
                    'input-file-drop-zone_drop_your_files_here_or_click_to_upload'
                        | translate: 'common' : 'brunata-angular-ui'
                }}
            </span>
        </div>
    `,
    styles: `
        .dropzone {
            margin: 0 auto;
            padding: 2rem;
            text-align: center;
            border-width: 2px;
            border-style: dashed;
            position: relative;
            min-height: 140px;
            justify-content: center;
            transition: border-color 0.15s;
        }

        .dropzone:hover {
            border-color: var(--bs-primary);
        }

        .bi-upload {
            transition: transform 0.15s;
        }

        .dropzone:hover .bi-upload {
            transform: translateY(-3px);
        }

        @media (prefers-reduced-motion: reduce) {
            .dropzone,
            .bi-upload {
                transition: none;
            }
        }

        .filled {
            border-width: 1px;
            border-style: solid;
            border-color: var(--bs-primary);
            background-color: rgba(var(--bs-primary-rgb), 0.03);
        }

        .title {
            font-weight: 700;
            font-size: 1.0625rem;
            overflow-wrap: anywhere;
        }

        .corner {
            position: absolute;
            top: 0.625rem;
            right: 0.625rem;
        }

        .file-input {
            cursor: pointer;
            opacity: 0;
            position: absolute;
            z-index: 2;
            width: 100%;
            height: 100%;
            top: 0;
            left: 0;
        }
    `,
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class InputFileDropZoneComponent {
    multiple = input(true);
    title = input<string | null>(null);
    badge = input<string | null>(null);
    mutedBadge = input(false);
    files = output<File[]>();

    protected handleFileInput(eventTarget: EventTarget | null): void {
        if (eventTarget instanceof HTMLInputElement && eventTarget.files != null) {
            this.files.emit(Array.from(eventTarget.files));
        }
    }
}
